import { CSSProperties } from "react";

export const styles: { [key: string]: CSSProperties } = {
  container: {
    width: "100vw",
    height: "100vh",
    backgroundColor: "#f5f5f5",
  },
  imageArea: {
    width: "100%",
    height: "30%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  loginContainer: {
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    marginRight: 5,
  },
  loginBox: {
    width: 330,
    padding: 4,
    borderRadius: 2,
    zIndex: 2,
    backgroundColor: "#fff",
  },
  mt1: {
    marginTop: 1,
  },
  mt2: {
    marginTop: 2,
  },
  saveButton: {
    alignItems: "center",
  },
  lisence: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
  },
  };
